import script from "./FormNotification.vue?vue&type=script&setup=true&lang=js"
export * from "./FormNotification.vue?vue&type=script&setup=true&lang=js"

import "./FormNotification.vue?vue&type=style&index=0&id=6da5c643&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6da5c643"]])

export default __exports__